import { Invitee } from '@/models/Invitation';

export type InviteeListMode = 'all' | 'affiliate' | 'standard';

export const isAffiliateInvitee = (invitee: Invitee): boolean => !!invitee.affiliateCode;

export const filterInvitees = (invitees: Invitee[], mode: InviteeListMode): Invitee[] => {
  switch (mode) {
    case 'affiliate':
      return invitees.filter(isAffiliateInvitee);
    case 'standard':
      return invitees.filter((invitee) => !isAffiliateInvitee(invitee));
    default:
      return invitees;
  }
};
